import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface WizardSurfaceStep {
    label: string;
    status?: 'default' | 'done' | 'fail';
    icon?: IconProp;
    doneIcon?: IconProp;
    failIcon?: IconProp;
    disabled?: boolean;
    badgeLabel?: string;
    badgeClass?: string;
}

@Component({
    selector: 'app-wizard-surface',
    templateUrl: './wizard-surface.component.html',
    styleUrls: ['./wizard-surface.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WizardSurfaceComponent {
    @Input() eyebrow = '';
    @Input() title = '';
    @Input() description = '';
    @Input() steps: WizardSurfaceStep[] = [];
    @Input() currentStep = 0;
    @Input() showStepper = true;
    @Input() maxWidthClass = 'max-w-6xl';
    @Input() contentClass = '';

    @Output() stepSelected = new EventEmitter<number>();
    @Output() currentStepChange = new EventEmitter<number>();

    selectStep(index: number): void {
        if (this.isStepDisabled(index) || this.currentStep === index) {
            return;
        }

        this.currentStep = index;
        this.currentStepChange.emit(index);
        this.stepSelected.emit(index);
    }

    selectStepFromPointer(event: PointerEvent, index: number): void {
        if (event.pointerType !== 'mouse' || event.button !== 0) {
            return;
        }

        this.selectStep(index);
    }

    isStepDisabled(index: number): boolean {
        return this.steps?.[index]?.disabled === true;
    }

    getStepIcon(step: WizardSurfaceStep): IconProp | null {
        if (step.status === 'done') {
            return step.doneIcon || ['fal', 'check-circle'];
        }

        if (step.status === 'fail') {
            return step.failIcon || ['fal', 'times-circle'];
        }

        return step.icon || null;
    }
}
